export default __webpack_public_path__ + "static/media/formas-digitales-banner-contacto.122a63db.png";